// extracted by mini-css-extract-plugin
export default {"footer":"PersonalInfoEditModal_footer__MmcCr","cancel_btn":"PersonalInfoEditModal_cancel_btn__Jg+u6"};